import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { ContextWrapper } from "./components/AppContext";
import Logo from "./components/Logo";
import Main from "./pages/main/Main";

const MainLayout = () => (
  <>
    <Logo />
    <Outlet />
  </>
);

const Layout = () => (
  <ContextWrapper>
      <BrowserRouter>
          <Routes>
              <Route element={<MainLayout />}>
                  <Route
                      path="/"
                      element={<Main />}
                  />
              </Route>
          </Routes>
      </BrowserRouter>
  </ContextWrapper>
);

export default Layout;
